import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingCart } from "lucide-react";
import { useCart } from "@/contexts/CartContext";
import { useIsMobile } from "@/hooks/use-mobile";

export const StickyMobileCart = () => {
  const { itemCount, total } = useCart();
  const isMobile = useIsMobile();
  const { pathname } = useLocation();

  const hiddenRoutes = ["/cart", "/checkout"];
  if (!isMobile || itemCount === 0 || hiddenRoutes.some(r => pathname.startsWith(r))) return null;

  return (
    <AnimatePresence>
      {/* Left-anchored pill — WhatsApp FAB stays on the right, no overlap */}
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-6 left-4 z-50"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      >
        <Link to="/cart">
          <motion.div
            whileTap={{ scale: 0.96 }}
            className="flex items-center gap-2.5 bg-primary text-primary-foreground rounded-full pl-2 pr-4 py-2 shadow-[0_8px_28px_-4px_rgba(0,60,180,0.55)] border border-white/10"
          >
            {/* Cart icon circle with badge */}
            <div className="relative shrink-0 w-9 h-9 rounded-full bg-white/15 flex items-center justify-center">
              <ShoppingCart className="w-4 h-4" />
              <span className="absolute -top-1 -right-1 min-w-[17px] h-[17px] rounded-full bg-white text-primary text-[10px] font-black flex items-center justify-center px-0.5 leading-none shadow-sm">
                {itemCount}
              </span>
            </div>

            {/* Label */}
            <span className="font-bold text-sm whitespace-nowrap">View Cart</span>

            {/* Price pill */}
            <span className="bg-white/20 text-white text-xs font-semibold rounded-full px-2.5 py-1 whitespace-nowrap">
              {total.toLocaleString()} DH
            </span>
          </motion.div>
        </Link>
      </motion.div>
    </AnimatePresence>
  );
};
